<script lang="ts">
	import HLS from 'hls.js'
	import Player from '#components/player.svelte'
	import Modal from '#components/modal.svelte'
	import Controls from '#components/controls.svelte'
	import type { Video } from 'storyloco/mux'

	interface Props {
		video: Video
		short?: boolean
		portrait?: boolean
		controls?: boolean
		aspect?: string
		node?: HTMLVideoElement
		paused?: boolean
		modal?: boolean
	}

	let {
		video,
		short = undefined,
		portrait = undefined,
		controls = true,
		aspect = undefined,
		node = $bindable(undefined),
		paused = $bindable(true),
		modal = $bindable(false)
	}: Props = $props()

	let { m3u8_url: src, autoplay, poster, loop } = $derived(video)
	let player = $state<HTMLVideoElement>()

	$effect(() => {
		if (src && node) {
			const hls = new HLS()
			hls.loadSource(src)
			hls.attachMedia(node)

			return () => hls.destroy()
		}
	})

	function play() {
		if (autoplay) {
			node?.play()
		} else {
			modal = true
		}
	}

	function pause() {
		node?.pause()
	}

	function full() {
		modal = true
	}
</script>

<div class="player">
	<video
		class="video"
		class:short
		class:portrait
		style:aspect-ratio={aspect}
		{src}
		{autoplay}
		{poster}
		{loop}
		muted
		playsinline
		bind:this={node}
		bind:paused
	></video>
	{#if controls}
		<Controls {autoplay} bind:paused {portrait} {play} {pause} {full} />
	{/if}
</div>

<Modal player close={() => (modal = false)} bind:open={modal}>
	<Player id={video?.playback_id} bind:player autoplay />
</Modal>

<style lang="css">
	.video {
		aspect-ratio: 5 / 6;
		object-fit: cover;
		size: 100%;

		@media (--from-mobile) {
			aspect-ratio: 16 / 9;
		}

		&.short {
			@media (--from-mobile) {
				aspect-ratio: 21 / 9;
			}
		}

		&.portrait {
			@media (--from-mobile) {
				aspect-ratio: 3 / 4;
			}
		}
	}
</style>
